import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './blog.scss';
import Seo, { SITE_URL } from '../components/seo/Seo';
import { getPost, postPath, PUBLISHED } from '../content/blog';
import { localeFromPath } from '../lib/i18n-routes';

function BlogList() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const lang = localeFromPath(pathname);

    useEffect(() => { window.scrollTo(0, 0); }, []);

    const path = lang === 'ru' ? '/ru/blog' : '/blog';
    const altPath = lang === 'ru' ? '/blog' : '/ru/blog';

    const items = PUBLISHED
        .map((p) => ({ ...p, content: getPost(p.slug, lang) }))
        .filter((p) => p.content)
        .sort((a, b) => (a.date < b.date ? 1 : -1));

    const schema = {
        '@context': 'https://schema.org',
        '@type': 'Blog',
        name: t('useful-info'),
        url: `${SITE_URL}${path}`,
        inLanguage: lang,
        blogPost: items.map((p) => ({
            '@type': 'BlogPosting',
            headline: p.content.h1,
            url: `${SITE_URL}${postPath(p, lang)}`,
            datePublished: p.date,
        })),
    };

    return (
        <main className="blog-list">
            <Seo
                title={t('blog-meta-title')}
                description={t('blog-meta-desc')}
                lang={lang}
                path={path}
                altPath={altPath}
                schema={schema}
            />

            <section className="svc-hero svc-hero--index">
                <div className="container">
                    <nav className="svc-crumbs" aria-label="breadcrumb">
                        <Link to={lang === 'ru' ? '/ru' : '/'}>Innobek</Link>
                        <span aria-hidden="true">/</span>
                        <span>{t('news')}</span>
                    </nav>

                    <span className="brand-asterisk svc-hero__mark">&#10033;</span>
                    <p className="h8 sub-title">{t('news')}</p>
                    <h1 className="svc-hero__title">{t('blog-page-title')}</h1>
                    <p className="svc-hero__lead">{t('blog-page-lead')}</p>
                </div>
            </section>

            <section className="svc-section">
                <div className="container">
                    <div className="blog-list__grid">
                        {items.map((p) => (
                            <Link className="blog-card" key={p.slug} to={postPath(p, lang)}>
                                {p.content.images?.[0] ? (
                                    <span className="blog-card__img">
                                        <img
                                            src={p.content.images[0].src}
                                            alt={p.content.images[0].alt}
                                            width="1400"
                                            height="875"
                                            loading="lazy"
                                            onError={(e) => { e.currentTarget.parentNode.style.display = 'none'; }}
                                        />
                                    </span>
                                ) : null}
                                <span className="blog-card__body">
                                    <span className="blog-card__tag">{p.content.category}</span>
                                    <h2 className="blog-card__title">{p.content.h1}</h2>
                                    <span className="blog-card__lead">{p.content.lead}</span>
                                    <span className="svc-related__more">{t('read-more')} &#8599;</span>
                                </span>
                            </Link>
                        ))}
                    </div>

                    {!items.length ? <p>{t('services-empty')}</p> : null}
                </div>
            </section>
        </main>
    );
}

export default BlogList;
